"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KonfektionierungDelegator = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_configurations_1 = require("@igus/echain-shared-configurations");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
class KonfektionierungDelegator {
    constructor() {
        this.className = 'KonfektionierungDelegator';
    }
    getList(availableKonfektionierungen, configuration) {
        const tarKonfs = echain_shared_articles_oo_1.KonfektionierungList.fromScratch();
        this.takeLeitungEinlegen(tarKonfs, availableKonfektionierungen, configuration)
            .takeOeffnungsstegSchliessen(tarKonfs, availableKonfektionierungen, configuration)
            .takeLeitungBeschriften(tarKonfs, availableKonfektionierungen, configuration)
            .takeZugentlastungMontieren(tarKonfs, availableKonfektionierungen, configuration)
            .takeTrommelAnschrauben(tarKonfs, availableKonfektionierungen, configuration)
            .takeVerpackungAuflegen(tarKonfs, availableKonfektionierungen, configuration)
            .takeVerpackungVerpacken(tarKonfs, availableKonfektionierungen, configuration)
            .takeVerpackungMaterial(tarKonfs, availableKonfektionierungen, configuration);
        return tarKonfs;
    }
    takeLeitungEinlegen(tar, src, configuration) {
        if (configuration.isNotVerpackungKonfektionierungApplicable()) {
            return this;
        }
        if (configuration.hasAnyFachboden()) {
            return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.leitungEinlegenMeterFactorChainWithFachboeden);
        }
        if (configuration.hasGeschlosseneKette()) {
            return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.leitungEinlegenMeterFactorChainClosed);
        }
        if (configuration.hasAnyTrennsteg()) {
            return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.leitungEinlegenMeterFactorChainWithTrennstegen);
        }
        return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.leitungEinlegenMeterFactorDefault);
    }
    takeOeffnungsstegSchliessen(tar, src, configuration) {
        const configModel = configuration.toModel();
        const { type, config } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configModel);
        // skip OeffnungsstegSchliessen if leitungLoseBeilegen (EKE-12337)
        if (configuration.leitungenLoseBeilegen) {
            return this;
        }
        switch (type) {
            case 'Empty': // no e-chain nothing to close ;-)
            case 'Espool': // no harnessing calculation for e-spool
            case 'EspoolChild':
                return this;
            case 'Kette': {
                const kette = (0, echain_shared_articles_oo_1.A)(config.Kette);
                // if e-chain not openable then we have no Oeffnungssteg to close ;-)
                if (kette.geschlossen) {
                    return this;
                }
                return this.use(tar, src, kette.bauform === echain_shared_articles_1.KetteBauform.rohr
                    ? echain_shared_articles_1.KonfektionierungTyp.schliessenOeffnungsstegFactorRohr
                    : echain_shared_articles_1.KonfektionierungTyp.schliessenOeffnungsstegFactorKette);
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
    takeLeitungBeschriften(tar, src, configuration) {
        if (configuration.hasLeitungAnyBeschriftung()) {
            return this.use(tar, src, configuration.getLeitungBeschriftungKonfektionierungTyp());
        }
        return this;
    }
    takeZugentlastungMontieren(tar, src, configuration) {
        if (configuration.isNotVerpackungKonfektionierungApplicable()) {
            return this;
        }
        const zugentlastungCountInfo = configuration.getCountOfLeitungenWithZugentlastung();
        if (zugentlastungCountInfo.count > 0) {
            return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.befestigungZugentlastungFactor);
        }
        return this;
    }
    takeTrommelAnschrauben(tar, src, configuration) {
        if (configuration.hasAnyVerpackungOfType(echain_shared_articles_1.VerpackungType.trommel)) {
            return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.auftrommelnTransportgestellAnschrauben);
        }
        return this;
    }
    takeVerpackungAuflegen(tar, src, configuration) {
        if (configuration.hasAnyVerpackungOfType(echain_shared_articles_1.VerpackungType.trommel)) {
            return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.auftrommelnRatePerMeter);
        }
        if (configuration.hasAnyVerpackungOfType(echain_shared_articles_1.VerpackungType.palette)) {
            return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.paletteRatePerMeter);
        }
        return this;
    }
    takeVerpackungVerpacken(tar, src, configuration) {
        if (configuration.hasAnyVerpackungOfType(echain_shared_articles_1.VerpackungType.karton)) {
            return this;
        }
        else if (configuration.hasAnyVerpackungOfType(echain_shared_articles_1.VerpackungType.trommel)) {
            const verpackungLength = configuration.getKetteVerpackungDurchmesser();
            if (verpackungLength) {
                if (verpackungLength.mm <= 1500) {
                    return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.verpackungTrommelUnder1501);
                }
                else {
                    return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.verpackungTrommelGreater1500);
                }
            }
        }
        else if (configuration.hasAnyVerpackungOfType(echain_shared_articles_1.VerpackungType.palette)) {
            const verpackungLength = configuration.getPaletteOrKartonBreite();
            if (verpackungLength) {
                if (verpackungLength.mm <= 900) {
                    return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.verpackungPaletteUnder901);
                }
                else {
                    return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.verpackungPaletteOver900);
                }
            }
        }
        return this;
    }
    takeVerpackungMaterial(tar, src, configuration) {
        if (configuration.hasAnyVerpackungOfType(echain_shared_articles_1.VerpackungType.trommel)) {
            return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.verpackungMaterialTrommel);
        }
        if (configuration.hasAnyVerpackungOfType(echain_shared_articles_1.VerpackungType.palette)) {
            return this.use(tar, src, echain_shared_articles_1.KonfektionierungTyp.verpackungMaterialPalette);
        }
        return this;
    }
    use(tar, src, typ) {
        const konfektionierung = src.getByTyp(typ);
        if (konfektionierung) {
            tar.add(konfektionierung);
        }
        return this;
    }
}
exports.KonfektionierungDelegator = KonfektionierungDelegator;
//# sourceMappingURL=KonfektionierungDelegator.js.map